<template lang="pug">
.dialog-container(id="DialogAssign-container")
  //- seems we need a hack for [enter] button
  button.invisible(v-if="enabled", style='opacity: .01', ref="submitButton", @keyup.enter="assignMediaToPlaylists()") {{  'invisible button '}}
  el-row.row(v-if="enabled")
    el-col.col-left(:span="10")
      h4 {{$t('Assign media')}}:
      hr.header
      ShortMediaList(id="DialogAssign-mediaList" ref='childrenList', :items='this.$store.state.Medium.media_selected_left.filter(m => !m.type.startsWith("PlayListLibrary"))', :showThumbs="true", :showMediaIcons="true")
    el-col.col-middle(:span="4")
      el-button.confirm(id="DialogAssign-assignButton" v-if='!saving', type="success", @click="assignMediaToPlaylists()", circle)
        font-awesome-icon.linker-icon(icon="link")
        | &nbsp; {{$t("Assign")}} &nbsp;
      el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
        font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
        .spinner-text {{ percentDone }}%
    el-col.col-right(:span="10")
      .playlists(v-if='assignPlayListTargets.length > 0 && this.$store.state.User.rightPanelChosen === "media"')
        h4 {{$t('to playlists / layouts')}}:
        hr.header
        ShortMediaList(id="DialogAssign-playlistList" ref='targetsListMedia', :items='assignPlayListTargets', :showThumbs="true", :showMediaIcons="true")
      .devices(v-if='onlyDesktopsSelected')
        h4 {{$t('to screens')}}:
        hr.header
        ShortMediaList(id="DialogAssign-screenList" ref='targetsListDevices', :items='desktopPlayListsSelected', :showThumbs="true", :showMediaIcons="true")
</template>

<script>

import ShortMediaList from '../Common/ShortMediaList'

export default {
  props: ['enabled'],
  components: {
    ShortMediaList
  },
  created () {
    this.$nextTick(() => {
      this.$refs.submitButton.focus()
    })
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0
    }
  },
  methods: {
    async assignMediaToPlaylists () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const toBeDoneOperationsMedia = this.$refs.targetsListMedia ? this.$refs.targetsListMedia.selectedItems.length * this.$refs.childrenList.selectedItems.length : 0
      const toBeDoneOperationsDevices = this.$refs.targetsListDevices ? this.$refs.targetsListDevices.selectedItems.length * this.$refs.childrenList.selectedItems.length : 0
      const toBeDoneOperations = toBeDoneOperationsMedia + toBeDoneOperationsDevices
      let doneSoFarOperations = 0
      if (toBeDoneOperationsMedia > 0) {
        for (const target of this.$refs.targetsListMedia.selectedItems) {
          for (const child of this.$refs.childrenList.selectedItems) {
            await this.$store.dispatch('Medium/assignMediumToPlaylist', [target.id, child.id])
            doneSoFarOperations++
            this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
          }
          this.$store.dispatch('User/sendBroadcastMessage', { Rooms: 'Playlist_changed', Data: { playlistId: target.id, userId: this.$store.state.User.user.id } })
        }
        this.$emit('linkerJobDone', 'assignToPlaylists')
      }
      if (toBeDoneOperationsDevices > 0) {
        for (const target of this.$refs.targetsListDevices.selectedItems) {
          for (const child of this.$refs.childrenList.selectedItems) {
            await this.$store.dispatch('Medium/assignMediumToPlaylist', [target.id, child.id])
            doneSoFarOperations++
            this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
          }
          await this.$store.dispatch('Medium/getMedium', {
            data: target.id,
            options: { populate: true }
          })
          this.$store.dispatch('User/sendBroadcastMessage', { Rooms: 'Playlist_changed', Data: { playlistId: target.id, userId: this.$store.state.User.user.id } })
        }
        this.$emit('linkerJobDone', 'assignToDevices')
      }
      this.saving = false
      this.percentDone = 0
    }
  },
  computed: {
    desktopPlayListsSelected () {
      const localPlayListsIdsOfSelectedDesktops = this.$store.state.Device.desktops_selected_right.map(dsr => dsr.LocalPlayList)
      return this.$store.state.Medium.local_playlists_cache.filter(medium => localPlayListsIdsOfSelectedDesktops.includes(medium.id))
    },
    assignPlayListTargets () {
      return this.$store.state.Medium.media_selected_right.filter(medium => medium.type.startsWith('PlayList'))
    },
    onlyDesktopsSelected () {
      return this.$store.state.Device.desktops_selected_right.length > 0 && this.$store.state.User.rightPanelChosen === 'devices'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogAssign.vue